import TestAutomator from './TestAutomator.js';
import Deck from '../../CribbageCore/src/Game/Deck.js';
import Analyzer from '../../CribbageCore/src/Game/Analyzer.js';
import PlayerComputer from '../../CribbageCore/src/Game/PlayerComputer.js'

export default class Test {
    constructor(app) {
        this.app = app;
        this.testAutomator = new TestAutomator(app);
    }
    startTestGame() {
        this.testAutomator.start()
    }
    startTestGameOnline() {
        this.testAutomator.start("onlineForver")
    }
    testAnalyzeHandRandom() {
        let deck = new Deck().createDeck();
        let preHand = deck.slice(0, 6);
        let hand = preHand.slice(0, 4);
        let isDealer = true;
        let analyzer = new Analyzer();
        let analysis = analyzer.analyzeHand(preHand, isDealer, hand);

        let gameController = this.app.controllers["Game"];
        gameController.showAnalyzeHand(analysis);
    }
    testAnalyzeHand(cardString, isDealer) {
        isDealer = !!isDealer;
        if (!cardString) cardString = "2c,3c,6c,8c,10s,ks";
        let preHand = Deck.createCardsFromArrayString(cardString);
        let hand = preHand.slice(0, 4);
        let analyzer = new Analyzer();
        let analysis = analyzer.analyzeHand(preHand, isDealer, hand);
        
        let gameController = this.app.controllers["Game"];
        gameController.showAnalyzeHand(analysis);
    }
    testAnalyzeHand2() {
        let preHand = Deck.createCardsFromArrayString("4s,4c,5c,5d,6s,6d");
        let hand = preHand.slice(0, 4);
        let isDealer = false;
        let analyzer = new Analyzer();
        let analysis = analyzer.analyzeHand(preHand, isDealer, hand);
        
        let gameController = this.app.controllers["Game"];
        gameController.showAnalyzeHand(analysis);
    }

    testShare() {
        this.app.share();
    }
    testFBGetData() {
        this.app.fBInstantGame.getDataAsync();
    };
    testFBsubscribeBot() {
        this.app.fBInstantGame.subscribeBot();
    };
    testReload() {
        //let randomNumber = Math.random();
        //window.location = "index.html?"+randomNumber;
        //window.applicationCache.swapCache();
        //window.location.reload(); //is opening in devices browser
        window.open("index.html", "_self");
       
    }
    testFBCreateShortcut() {
        this.app.fBInstantGame.createShortcut();
    }
    testShowInvite() {
        let user = this.app.userdata;
        let invite = {
            name: user.name,
            userId: user.id,
            avatar: user.avatar,
            room: user.id,
        };
        this.app.showInvitePopup(invite);
    }
    testShowAchievementPopup() {
        let achievements = [{
            "name": "5 Easy Wins",
            "category": "Easy",
            "title": "Piece of Cake",
            "description": "Win 5 matches on Easy",
            "image": "cake-slice.png",
            "points": "25",
        }];
        this.app.showAchievementPopup(achievements);
    }
    testNotification() {
        this.app.createNotification("Invite sent");
    }
    testShowSharePopup() {
        this.app.showSharePopup("You have played a zillion times. Do you like Cribbage yet?");
    }
    testShowDelayedPrompt() {
        this.app.prompter.delayedPrompt(10);
    }
    testTryShowAd() {
        this.app.showAd();
    }
    testShowAd() {
        this.app.showAd(true);
    }
    testShowAppOpenAd() {
        this.app.showAppOpenAd(true);
    }
    tryShowAppOpenAd() {
        this.app.tryShowAppOpenAd(10000);
    }
    showMediationTestSuite() {
        this.app.advertisement.showMediationTestSuite();
    }
    showAdInspector() {
        this.app.advertisement.showAdInspector();
    }
    testFullVersion(value) {
        this.app.userdata.fullVersion = value;
        this.app.fullVersion = value;
        this.app.createNotification("fullVersion = " + value);
    }
    testRemoveAds(value) {
        this.app.userdata.removeAds = value;
        this.app.createNotification("removeAds = " + value);
    }
    testGiveCoins() {
        this.app.userdata.coins = (this.app.userdata.coins || 0) + 2000;
        this.app.createNotification("Your have received 2,000 coins");
    }
    testSocketDisconnectClean() {
        this.app.gameServer.close(1000);
    }
    testSocketDisconnectDirty() {
        this.app.gameServer.close(3000);
    }
    testSocketLogin() {
        this.app.gameServer.login(this.app.userdata);
    }
    testPushNotificationRegister() {
        this.app.pushNotification.RegisterNotification().then(message => {
            this.app.createNotification("RegisterNotification = " + message);
        });
    }
    testGetOS() {
        let os = this.app.device.getOS()
        this.app.createNotification("device.getOS = " + os);
    }
    testAvatarUpload() {
        let id = -1;
        let imageUrl = 'https://live.staticflickr.com/65535/50995000278_78db4a0539_w_d.jpg';
        this.app.accountJD.UploadAvatarUrl(id, imageUrl).then((url) => {
            if (url) this.app.createNotification("uploaded: " + url);
            if (!url) this.app.createNotification("failed upload");
        });
    }
    testAvatarUploadFile(id, file) {
        if (!id) id = -1;
        this.app.accountJD.UploadAvatar(id, file).then((url) => {
            if (url) this.app.createNotification("uploaded: " + url);
            if (!url) this.app.createNotification("failed upload");
        });
    }
    testAvatarUploadUrl(id, imageUrl) {
        if (!id) id = -1;
        if (!imageUrl) imageUrl = 'https://live.staticflickr.com/65535/50995000278_78db4a0539_w_d.jpg';
        this.app.accountJD.UploadAvatarUrl(id, imageUrl).then((url) => {
            if (url) this.app.createNotification("uploaded: " + url);
            if (!url) this.app.createNotification("failed upload");
        });
    }
    testLoadGame() {
        this.app.loadGame().then((game) => {
            this.app.createNotification("loadGame(): ");
        });
    }
    testWEBGL_lose_context() {
        var canvas = this.app.game.renderer.view;
        var gl = canvas.getContext('webgl');
        if (!gl) gl = canvas.getContext('webgl2');

        canvas.addEventListener('webglcontextlost', function (e) {
            console.log(e);
        }, false);

        gl.getExtension('WEBGL_lose_context').loseContext();
    }
    testWEBGL_restoreContext() {
        var canvas = this.app.game.renderer.view;
        var gl = canvas.getContext('webgl');
        if (!gl) gl = canvas.getContext('webgl2');

        canvas.addEventListener('webglcontextrestored', function (e) {
            console.log(e);
        }, false);

        gl.getExtension('WEBGL_lose_context').restoreContext();
    }
    testRateAppNative() {
        this.app.rateApp.rateNative();
    }
    requestTrackingAuthorizationWithExplainer() {
        this.app.requestTrackingAuthorizationWithExplainer(true);
    }
    requestTrackingAuthorization() {
        this.app.requestTrackingAuthorization();
    }
    testEnableDebug() {
        this.app.debug = true;
        this.app.createNotification("app.debug = true");
    }
    testDisableDebug() {
        this.app.debug = false;
        this.app.createNotification("app.debug = false");
    }
    testShowDebugWindow() {
        this.app.showDebug();
    }
    testShowEndRound() {
        const controller = this.app.controllers["Game"];
        controller.cribbage.setState("endRound");
    }
    autoPlayStartFast() {
        this.autoPlayStop();
        let gameController = this.app.controllers["Game"];
        let cribbage = gameController.cribbage;
        let tablePosition = gameController.tablePosition;
        this.playerComputer = new PlayerComputer(cribbage, tablePosition, 300, "test", "InsaneMonkey", "InsaneMonkey");
        this.playerComputer.randomChat = false;
        this.playerComputer.welcomeChat = true;
        this.playerComputer.doAction();
    }
    autoPlayStartHuman() {
        this.autoPlayStop();
        let gameController = this.app.controllers["Game"];
        let cribbage = gameController.cribbage;
        let tablePosition = gameController.tablePosition;
        this.playerComputer = new PlayerComputer(cribbage, tablePosition, 1200, "test", "Hard", "Hard");
        this.playerComputer.randomChat = false;
        this.playerComputer.welcomeChat = true;
        this.playerComputer.doAction();
    }
    autoPlayStop() {
        if (this.playerComputer) {
            this.playerComputer.destroy();
            this.playerComputer = null;
        }
    }
    winGame() {
        let gameController = this.app.controllers["Game"];
        let cribbage = gameController.cribbage;
        cribbage.forceWin("player1");
    }

}